/** Company has sunbed post-session cooling enabled (`is_sunbed_cooling` on company/settings). */
export function hasSunbedCoolingEnabled(user: unknown): boolean {
  const raw = (user as { company?: { is_sunbed_cooling?: unknown } } | null)?.company
    ?.is_sunbed_cooling;
  return raw === true || raw === 1 || raw === "1" || raw === "active";
}
